import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const SiteNav = ({ onStartAudit, onAccessCode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  const linkCls =
    "text-sm text-brand-green hover:text-brand-goldDark font-medium transition-colors";

  return (
    <nav className="sticky top-0 z-40 backdrop-blur-md bg-brand-bone/85 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-home-logo"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 font-heading font-extrabold text-lg"
        >
          <span className="text-brand-green">3E</span>
          <span className="text-brand-gold">Leak Finder</span>
        </button>

        <div className="flex items-center gap-5 sm:gap-6">
          <button data-testid="nav-home-link" onClick={() => navigate("/")} className={`hidden md:inline ${linkCls}`}>
            Home
          </button>
          <button data-testid="nav-how-link" onClick={() => goSection("what-it-checks")} className={`hidden md:inline ${linkCls}`}>
            How It Works
          </button>
          <button data-testid="nav-pricing-link" onClick={() => goSection("pricing")} className={`hidden md:inline ${linkCls}`}>
            Pricing
          </button>
          <button data-testid="nav-about-link" onClick={() => navigate("/about")} className={linkCls}>
            About Frank
          </button>
          {onAccessCode && (
            <button
              data-testid="nav-access-code-btn"
              onClick={onAccessCode}
              className={`hidden lg:inline ${linkCls}`}
            >
              Have an access code?
            </button>
          )}
          <Button
            data-testid="nav-start-btn"
            onClick={onStartAudit}
            className="rounded-full bg-brand-green hover:bg-brand-greenDark text-white uppercase tracking-wide text-xs font-semibold"
          >
            Start Audit
          </Button>
        </div>
      </div>
    </nav>
  );
};
